import {FIELD_TYPE} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
const {INPUT,DATE_DISABLE_NO_DAY, SELECT, DATE, COLOR,NUMBER} = FIELD_TYPE;
const css = { xs: 24, sm: 24, md: 24, lg: 8, xl: 8 };
const dataFields: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã nghỉ phép",
    name: "maNghiPhep",
    disable: false,
    rules: [{required: true, message: "Chưa nhập mã nghỉ phép"}],
    css:css,
    wrapperCol: { xs: 24,sm:14, md: 14, lg: 15, xl: 15 },
    labelCol: { xs: 24,sm:10, md: 10, lg: 9, xl: 9},
  },
  {
    type: NUMBER,
    label: "Phép tháng",
    name: "phepThang",
    rules: [{required: true, message: "Chưa nhập phép tháng"}],
    css:css,
    wrapperCol: { xs: 24,sm:14, md: 14, lg: 15, xl: 15 },
    labelCol: { xs: 24,sm:10, md: 10, lg: 9, xl: 9},
  },
  {
    type: NUMBER,
    label: "Phép ốm năm",
    name: "phepNghiOmNam",
    rules: [{required: true, message: "Chưa nhập phép ốm năm"}],
    css:css,
    wrapperCol: { xs: 24,sm:14, md: 14, lg: 15, xl: 15 },
    labelCol: { xs: 24,sm:10, md: 10, lg: 9, xl: 9},
  },
  {
    type: DATE_DISABLE_NO_DAY,
    label: "Ngày áp dụng từ ngày",
    name: "ngayApDungTu",
    disableDate:false,
    css:css,
    wrapperCol: { xs: 24,sm:14, md: 14, lg: 15, xl: 15 },
    labelCol: { xs: 24,sm:10, md: 10, lg: 9, xl: 9},
  },
  {
    type: DATE_DISABLE_NO_DAY,
    label: "Ngày áp dụng đến ngày",
    name: "ngayApDungDen",
    disableDate:false,
    css:css,
    wrapperCol: { xs: 24,sm:14, md: 14, lg: 15, xl: 15 },
    labelCol: { xs: 24,sm:10, md: 10, lg: 9, xl: 9},
  },


];
export {dataFields};
